import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api_url } from "../../../constant/constant";
import { showToast } from "../../../Components/ShowToast/ToastNotification";
import { useTranslation } from "react-i18next";

const CampaignExam = () => {
    const navigate = useNavigate();
    const location = useLocation();
    console.log('location',location)
    const compaign_id = location.state?.campaign_id;
    const { t } = useTranslation();

    const [quizData, setQuizData] = useState(null);
    const [currentQuestion, setCurrentQuestion] = useState(0);
    const [answers, setAnswers] = useState([]);
    const [examAnswers, setExamAnswers] = useState([]);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [quizCompleted, setQuizCompleted] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [score, setScore] = useState(null); 
    const [percentage, setpercentage] = useState(null); 

    useEffect(() => {
        
        const fetchData = async () => {
            try {
                const token = localStorage.getItem('userToken');
                const response = await fetch(`${api_url}/user/get-exam-details/${compaign_id}`, {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                });

                const result = await response.json();
                if (result.status === "success") {
                    setQuizData(result.exam?.questions);
                }
            } catch (error) {
                setError(t("failedtoloadcampaigndata"));
                showToast(t("failedtoloadcampaigndata"), "error");
            }            
        };

        fetchData();
    }, [compaign_id]);

    const handleAnswerSelect = (index) => {
        const newAnswers = [...answers];
        newAnswers[currentQuestion] = index;
        setAnswers(newAnswers);
    };

    const handleNext = async () => {
        if (answers[currentQuestion] === undefined) {
          setError(t("pleaseselectanoptionbeforeproceeding"));
          showToast(t("pleaseselectanoptionbeforeproceeding"), "error");
          return;
        }
        setError("");

        const selectedOption = quizData[currentQuestion]?.options[answers[currentQuestion]];
        const questionId = quizData[currentQuestion].question_id;
        const answerId = selectedOption.option_id;
      
        const updatedAnswers = [
          ...examAnswers.filter(ans => ans.question_id !== questionId),
          { question_id: questionId, answer_id: answerId },
        ];
      
        setExamAnswers(updatedAnswers);
      
        if (currentQuestion < quizData.length - 1) {
          setCurrentQuestion(prev => prev + 1);
        } else {
          await handleSubmit(updatedAnswers);
          setQuizCompleted(true);
        }
      };
      
      
      

      const handleSubmit = async (finalAnswers) => {
        setLoading(true);
        setError("");
      
        try {
          const response = await fetch(`${api_url}/user/submit-exam-answers`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${localStorage.getItem('userToken')}`,
            },
            body: JSON.stringify({
              campaign_id: compaign_id,
              answers: finalAnswers || examAnswers, 
            }),
          });
      
          const data = await response.json();
      
          if (!response.ok) {
            showToast(t("failedtosubmitanswers") || data.message, "error");
            return;
          }
      
          if (data.status === "success") {
            showToast(t("quizsubmittedsuccessfully"), "success");
            setSubmitted(true);
            setScore(data.total_score);
            setpercentage(data.percentage);
          }
        } catch (err) {
          setError(t("anerroroccurredwhilesubmittingyouranswers"));
          showToast(t("anerroroccurredwhilesubmittingyouranswers"), "error");
        } finally {
          setLoading(false);
        }
      };
      

    if (!quizData) {
        return (
            <div className="d-flex justify-content-center align-items-center vh-100">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">{t('Loading')}...</span>
                </div>
            </div>
        );
    }

    return (
        <div className="quiz-container">
            {!quizCompleted ? (
                <>
            
                    <h2>{quizData[currentQuestion]?.question}</h2>
                    <div className="options">
                        {quizData[currentQuestion]?.options.map((option, index) => (
                            <label key={option.option_id} className="option">
                                <input
                                    type="radio"
                                    name={`question-${currentQuestion}`}
                                    checked={answers[currentQuestion] === index}
                                    onChange={() => handleAnswerSelect(index)}
                                    disabled={loading}
                                />
                                {option.answer}
                            </label>
                        ))}
                    </div>
                    {error && <div className="error-message">{error}</div>}
                    {loading && <div className="loading-text">{t('Submittinganswer')}...</div>}
                    <div className="quiz-buttons">
                        <button onClick={handleNext} disabled={loading}>
                            {currentQuestion === quizData.length - 1 ? t("Finish") : t("Next")}
                        </button>
                    </div>
                </>
            ) : (
                <div className="quiz-container text-center p-4 border rounded shadow-sm">
                     <img
            src="/images/icon1.png"
            alt="Result Icon"
            className="result-icon mb-4"
            style={{ width: "100px", height: "100px" }}
          />
                    <h4>{t('Thanksforsubmittinganswers')}!</h4>
                    {score !== null && (
                        <>
                        <h5 className="mt-3">
                            {t("obtainedmarks")}: <strong>{score}</strong>
                        </h5>
                        <h6 className="mt-2">
                    {t("Percentage")}: <strong>{percentage}%</strong>
                </h6>
                        </>
                    )}
                    <button onClick={() => navigate("/user/dashboard")} disabled={loading} className="btn btn-primary mt-3">
                        {loading ? t("Loading...") : t("Next")}
                    </button>
                </div>
            )}
        </div>
    );
};

export default CampaignExam;